export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    id: "faq1",
    question: "如何按类型和时长筛选视频？",
    answer:
      "在首页“视频库”区块中，顶部分别提供了类型筛选（娱乐八卦、明星动态、影视花絮、综艺名场面、幕后探班）与时长筛选（5分钟内的短视频、5-20分钟的中视频、20分钟以上的长视频）两个选项。你可以单选或多选组合，页面会实时更新视频列表，帮你快速定位想看的内容。",
  },
  {
    id: "faq2",
    question: "平台上的视频都来自哪里？",
    answer:
      "我们只聚合公开、合法的娱乐内容，包括各大平台的公开资讯、节目片段、官方花絮与公开活动画面等，均来自公开渠道并标注来源。本站不提供、不转载任何涉及他人隐私或个人监控的内容。",
  },
  {
    id: "faq3",
    question: "收藏或追更的视频会丢失吗？",
    answer:
      "你通过“追更”收藏的观看进度和收藏列表会保存在本地，正常清理浏览器缓存前不会丢失。如需多设备同步收藏，可稍后在设置中绑定账号开启云同步。",
  },
  {
    id: "faq4",
    question: "视频播放卡顿或无法加载怎么办？",
    answer:
      "建议先切换网络环境或刷新重试，其次确认浏览器已开启 JavaScript。若仍无法播放，可尝试更换播放清晰度，或在页面右下角“意见反馈”中向我们描述具体问题。",
  },
  {
    id: "faq5",
    question: "如何反馈视频问题或内容建议？",
    answer:
      "你可以在页面底部“联系与订阅”区域提交反馈表单，也可以直接发送邮件至 hello@chigua-video.cn。我们会安排专人逐条查看，并在后续更新中优先处理高频反馈。",
  },
  {
    id: "faq6",
    question: "你们的更新频率如何？",
    answer:
      "热门吃瓜与综艺名场面板块基本保持每日更新，深度专题栏目每周更新 2-3 期。订阅“吃瓜速递”后，重要更新会第一时间推送到你填写的邮箱。",
  },
];